// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
    production: true,
    staging: true,
    firebaseConfig: {
        apiKey: 'AIzaSyBKs6ACeacVPflivins1-CDksfn3aQQf34',
        authDomain: 'sopo-master.firebaseapp.com',
        databaseURL: 'https://sopo-master.firebaseio.com',
        projectId: 'sopo-master',
        storageBucket: 'sopo-master.appspot.com',
        messagingSenderId: '321246270632',
        appId: '1:321246270632:web:64df5d14be4c9d67',
        measurementId: 'G-NPWJ52348R'
    },
    apiUrl: 'https://api.staging.playsopo.com/',
    webClientId: '321246270632-43des8ej377odba84f6q0ba7qp6u3ur1.apps.googleusercontent.com',
    cmsUrl: 'https://staging-cms.playsopo.com/api/',
    bearerToken: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6Ijc3M',
    advertisementID: 'ca-app-pub-3940256099942544/1712485313', // This id is for test purposes.
    nftAggregatorUrl: 'https://nft-aggregator-dot-sopo-master.uc.r.appspot.com/',
    mapsApiKey: 'AIzaSyC6iT7FS3YL5G3x2kWfv_UKbg_kVUTVWrQ',
    sentryDsnDesktop: 'https://034486123694f7532d2048470e49b789@o4508327876952064.ingest.us.sentry.io/4508483209592832',
    sentryDsnWeb: 'https://7fa8b4d537941a12406b7e04ac59be4f@o4508327876952064.ingest.us.sentry.io/4511026183471104',
    iap: {
        ios: 'appl_XsmOOZTexjYdqevgSSGVBJwGjth',
        android: 'goog_TqFVlOXSBJYVchNfVbiWQyHAqTZ',
        web: 'rcb_eztcswFLIiJJOoQIWYHfyNLNdhPz',
    },
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
